import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import VN from "../components/VN";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Select,
  TextField,
  Button,
  Container,
  Typography,
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { apiRequest } from "../components/Config";
import { UserDataContext } from "../components/UserDataContext";
import LocationSelect from "../components/LocationSelect";
import PasswordFields from "../components/PasswordFields";
import { API_URL } from "../App";
import axios from "axios";

export default function RegisterClient() {
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const [voivodeshipList, setVoivodeshipList] = useState([]);
  const [cities, setCities] = useState([]);
  const [textEmail, setTextEmail] = useState("");
  const [showTextEmail, setShowTextEmail] = useState(false);
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState("");
  const [textPhone, setTextPhone] = useState("");
  const [showTextPhone, setShowTextPhone] = useState(false);
  const [showEmailVerifyInput, setShowEmailVerifyInput] = useState(false);
  const [emailCode, setEmailCode] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const [verifyMessage, setVerifyMessage] = useState("");

  useEffect(() => {
    apiRequest("voivodeship").then(setVoivodeshipList);
  }, []);

  const fetchCities = async (id) => {
    const res = await apiRequest(`cities/${id}`);
    setCities(res || []);
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Podaj poprawny email")
      .required("Email jest wymagany"),

    phone: Yup.string()
      .required("Telefon jest wymagany")
      .length(9, "Telefon musi mieć 9 cyfr"),

    fullName: Yup.string().required("Nazwisko i imię wymagane"),

    password: Yup.string().min(6, "Min. 6 znaków").required("Hasło wymagane"),

    passwordrepeat: Yup.string()
      .oneOf([Yup.ref("password")], "Hasła muszą być identyczne")
      .required("Powtórz hasło"),

    voivodeship: Yup.string().required("Wybierz województwo"),

    city: Yup.object().nullable().required("Wybierz miasto"),

    rodo: Yup.boolean().oneOf([true], "Wymagana zgoda"),
  });

  useEffect(() => {
    const fetchData = async () => {
      const url = API_URL + `/verify-account-email`;
      try {
        const response = await axios.post(
          url,
          { email: email },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (parseInt(response.data.email) > 0) {
          setTextEmail("Taki email już istnieje w systemie!");
          setShowTextEmail(true);
        } else {
          setShowTextEmail(false);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [email]);
  useEffect(() => {
    console.log("verify phone");
    const fetchData = async () => {
      const url = API_URL + `/verify-account-phone`;
      try {
        const response = await axios.post(
          url,
          { phone: phone },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (parseInt(response.data.phone) > 0) {
          setTextPhone("Taki numer już istnieje w systemie!");
          setShowTextPhone(true);
        } else {
          setShowTextPhone(false);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [phone]);
  return (
    <div>
      <VN userData={userData} />
      <Container maxWidth="sm">
        <Box mt={5}>
          <Typography variant="h5">Rejestracja osoby szukającej</Typography>

          <Formik
            initialValues={{
              email: "",
              phone: "",
              fullName: "",
              password: "",
              passwordrepeat: "",
              voivodeship: "",
              city: null,
              rodo: false,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
              await apiRequest("register", "POST", {
                ...values,
                city: values.city.id,
                accountType: 2,
              });
              navigate("/login", { state: { registered: true } });
            }}
          >
            {({ values, handleChange, setFieldValue, errors, touched }) => (
              <Form>
                <TextField
                  name="email"
                  label="Email"
                  fullWidth
                  margin="normal"
                  value={values.email}
                  onChange={(e) => {
                    handleChange(e);
                    setEmail(e.target.value);
                  }}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
                {showTextEmail && textEmail}
                {!emailVerified && values.email && !showTextEmail && (
                  <Button
                    size="small"
                    variant="outlined"
                    sx={{ mt: 1 }}
                    onClick={async () => {
                      await apiRequest("send-email-code-register", "POST", {
                        email: values.email,
                      });
                      setShowEmailVerifyInput(true);
                      setVerifyMessage("Kod został wysłany na email");
                    }}
                  >
                    Zweryfikuj email
                  </Button>
                )}
                {showEmailVerifyInput && !emailVerified && (
                  <Box display="flex" gap={1} alignItems="center" mt={1}>
                    <TextField
                      label="Kod z emaila"
                      value={emailCode}
                      onChange={(e) => setEmailCode(e.target.value)}
                      size="small"
                      fullWidth
                    />

                    <Button
                      variant="contained"
                      size="small"
                      onClick={async () => {
                        try {
                          const response = await apiRequest(
                            "verify-email-code-register",
                            "POST",
                            {
                              email: values.email,
                              code: emailCode,
                            },
                          );

                          if (response.success) {
                            setEmailVerified(true);
                            setVerifyMessage("Email zweryfikowany ✔");
                          } else {
                            setVerifyMessage("Nieprawidłowy kod");
                          }
                        } catch (err) {
                          console.error(err);
                          setVerifyMessage("Błąd weryfikacji");
                        }
                      }}
                    >
                      OK
                    </Button>
                  </Box>
                )}
                {verifyMessage && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {verifyMessage}
                  </Typography>
                )}
                <TextField
                  name="phone"
                  label="Telefon"
                  fullWidth
                  margin="normal"
                  value={values.phone}
                  onChange={(e) =>
                    setFieldValue(
                      "phone",
                      e.target.value.replace(/\D/g, "").slice(0, 9),
                    )
                  }
                  error={touched.phone && Boolean(errors.phone)}
                  helperText={touched.phone && errors.phone}
                />
                {showTextPhone && textPhone}
                <TextField
                  name="fullName"
                  label="Nazwisko i Imię"
                  fullWidth
                  margin="normal"
                  value={values.fullName}
                  onChange={handleChange}
                  error={touched.fullName && Boolean(errors.fullName)}
                  helperText={touched.fullName && errors.fullName}
                />

                <PasswordFields
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  touched={touched}
                />

                <LocationSelect
                  values={values}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="rodo"
                      checked={values.rodo}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Wyrażam zgodę na przetwarzanie danych (RODO)"
                />

                {touched.rodo && errors.rodo && (
                  <FormHelperText error>{errors.rodo}</FormHelperText>
                )}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 2 }}
                  disabled={!emailVerified}
                >
                  Zarejestruj
                </Button>
              </Form>
            )}
          </Formik>
        </Box>
      </Container>
    </div>
  );
}
